<template>
<!-- <div class="elevator"></div> -->

	<v-list dense class="elevator" >
		<v-list-tile 
			v-for="(item, index) in items" 
			:key="item" avatar 
			@click="clickHandler(item)"
			v-bind:class="{ selected: currentFloor == item}"
		>
<!-- 		<v-flex align-content-center>{{item}}</v-flex> -->
			<v-list-tile-content>
				<v-list-tile-title align-center v-text="item"></v-list-tile-title>
			</v-list-tile-content>
		</v-list-tile>
	</v-list>


</template>

<script>
import { mapState, mapMutations } from 'vuex'

let ElevatorControl = {

	data() {
		return {
			selected : "",
			floors: [{ text : 'Floor B', value: 'B' },
					{ text : 'Floor 1', value: '1' },
					{ text : 'Floor 2', value: '2' },
					{ text : 'Floor 3', value: '3' },
					{ text : 'Floor 4', value: '4' },
					{ text : 'Floor 5', value: '5' },
					{ text : 'Floor 6', value: '6' },
					{ text : 'Floor 7', value: '7' },
					{ text : 'Floor 8', value: '8' },
					{ text : 'Floor 9', value: '9' },
					{ text : 'Floor 10', value: '10' },
					{ text : 'Floor 11', value: '11' },
					{ text : 'Floor 12', value: '12' }],
		}
	},
	components: {  },

	computed: {
		...mapState({
		building: state => state.space.selectedBuilding,
		currentFloor: state => state.ui.currentFloor,
	  }),
	  	items: function () {
	  		//console.log(this.building.floors)
	  		return this.building && this.building.floors || this.floors.map((item) => item.value)
	  	}
	},

	methods: {
		...mapMutations(['setCurrentFloor']),

		clickHandler: function (floornumber) {
			this.setCurrentFloor(floornumber)
		}
	}, 

}

export default ElevatorControl

</script>

<style>

.elevator {
	margin-top:60px;
	height: 100%;
}

.selected {
	/*background-color: lightblue;*/
	background-color: #a2a2a2;;
}

.elevatortile:first {
	border-top-style: solid;
	background-color: black;
}

</style>




// WEBPACK FOOTER //
// src/components/buildingcard/ElevatorControl.vue